<template>
  <section class="latest-insights-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i class="fas fa-star"></i>
          <span>{{ content.header.tag }}</span>
        </div>
        <h2>{{ content.header.title }}</h2>
        <p class="section-description">{{ content.header.description }}</p>
        <div class="navigation-arrows d-flex justify-content-center">
          <button class="arrow-btn prev-btn">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="arrow-btn next-btn">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
    
    <div class="insights-slider swiper" ref="insightsSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(insight, index) in content.items" :key="index">
          <div class="insight-card">
            <div class="insight-image-container">
              <img :src="insight.image" :alt="insight.title" class="insight-image" />
              <div class="category-tags">
                <span v-for="(tag, tagIndex) in insight.tags" :key="tagIndex" class="category-tag">{{ tag }}</span>
              </div>
            </div>
            <div class="insight-content">
              <h3 class="insight-title">{{ insight.title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: 'FullScreenSliderComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup() {
    const insightsSwiper = ref(null)

    const initInsightsSwiper = () => {
      setTimeout(() => {
        const checkSwiper = () => {
          if (window.Swiper) {
            insightsSwiper.value = new window.Swiper('.insights-slider', {
              loop: true,
              autoplay: {
                delay: 4000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.next-btn',
                prevEl: '.prev-btn',
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              },
            })
          } else {
            setTimeout(checkSwiper, 100)
          }
        }
        checkSwiper()
      }, 100)
    }

    onMounted(() => {
      initInsightsSwiper()
    })

    return {
      insightsSwiper
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Latest Insights Section */
.latest-insights-section {
  padding: 120px 0;
  background: #0a0a0a;
  position: relative;
  overflow: hidden;
}

.latest-insights-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #FB0E76, #910694);
  color: #fff;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.section-tag i {
  font-size: 10px;
}

.section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.section-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto 30px;
  line-height: 1.6;
}

.navigation-arrows {
  gap: 15px;
}

.arrow-btn {
  width: 50px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.arrow-btn:hover {
  border-color: #FB0E76;
  background: #FB0E76;
  transform: scale(1.1);
}

.arrow-btn i {
  font-size: 14px;
}

/* Swiper Styles */
.insights-slider {
  padding: 0 20px;
}

.insight-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.insight-card:hover {
  transform: translateY(-10px);
  border-color: rgba(251, 14, 118, 0.3);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.insight-image-container {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.insight-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.insight-card:hover .insight-image {
  transform: scale(1.1);
}

.category-tags {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.category-tag {
  background: rgba(251, 14, 118, 0.9);
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.insight-content {
  padding: 20px;
}

.insight-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  line-height: 1.4;
  font-family: 'Archivo', sans-serif;
}

/* Responsive Design */
@media (max-width: 991px) {
  .latest-insights-section {
    padding: 80px 0;
  }
  
  .section-header h2 {
    font-size: 42px;
  }
  
  .section-description {
    font-size: 16px;
  }
}

@media (max-width: 767px) {
  .section-header h2 {
    font-size: 36px;
  }
  
  .insight-image-container {
    height: 180px;
  }
  
  .insight-content {
    padding: 15px;
  }
  
  .insight-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-description {
    font-size: 14px;
  }
  
  .arrow-btn {
    width: 45px;
    height: 45px;
  }
  
  .insight-image-container {
    height: 160px;
  }
}
</style>
